import {BDCPConstsService} from './services/consts.service';
import {BDCPFolderService} from './services/folder-service/folder.service';
import {BDCPKeyFeatureFilterPipe} from './pipes/key-feature-filter.pipe';
import {BDCPProductAttributePipe} from './pipes/product-attribute.pipe';
import {BDCPProductAttributeSortPipe} from './pipes/product-attribute-sort.pipe';
import {BDCPProductsService} from './services/products-service/products.service';
import {BDCPShareService} from './services/share.service';
import {BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {IBDCPFolderService} from './services/folder-service/folder.interface';
import {IBDCPProductsService} from './services/products-service/products.interface';
import {NgModule} from '@angular/core';
import {BDCPProductResultComponent} from './components/product-result/product-result.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BDSharedModule
    ],
    declarations: [
        // Components
        BDCPProductResultComponent,
        // Pipes
        BDCPKeyFeatureFilterPipe,
        BDCPProductAttributePipe,
        BDCPProductAttributeSortPipe
    ],
    providers: [
        BDCPConstsService,
        BDCPShareService,
        {provide: IBDCPProductsService, useClass: BDCPProductsService},
        {provide: IBDCPFolderService, useClass: BDCPFolderService},
    ],
    exports: [
        // Components
        BDCPProductResultComponent,
        // Pipes
        BDCPKeyFeatureFilterPipe,
        BDCPProductAttributePipe,
        BDCPProductAttributeSortPipe
    ]
})
export class BDCPSharedModule {
}
